import React, { Fragment } from 'react';
import Analytics from '@jetshop/core/analytics/Analytics';
import { trackList } from '@jetshop/core/analytics/tracking';
import theme from '@jetshop/ui/utils/theme';
import styled from 'react-emotion';
import ListProduct from './ListProduct';
import { Price } from '../Price';

const ProductGridContainer = styled('div')`
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;
  margin-right: -${theme('space.1')};
  margin-left: -${theme('space.1')};
  > div {
    width: 100%;

    margin-bottom: 20px;
    &:last-child {
      border-bottom: 0;
    }
    summary {
      overflow: hidden;
      .custom-tabs {
        display: none;
      }
    }
    section {
      > div {
        display: flex;
        align-items: baseline;
        justify-content: center;
        margin-top: 10px;

        div {
          margin: 0 5px;
        }

        ${Price.Old} {
          color: #636363;
          font-size: 15px;
        }
      }
    }
  }
`;

const productPlaceholder = {
  id: Math.random(),
  name: '',
  images: []
};
const ProductList = ({
  className = '',
  products,
  loading,
  listName,
  categoryPath = null,
  ProductComponent = ListProduct,
  self
}) => {
  const productList =
    products.length === 0 && loading
      ? Array(4).fill(productPlaceholder)
      : products;

  return (
    <ProductGridContainer data-testid="product-grid">
      {products && (
        <Fragment>
          {!loading ? (
            <Analytics
              track={trackList({
                listName,
                products: products
              })}
            />
          ) : null}
          {productList.map((product) => {
              return product.id !== self ? (
                <ProductComponent
                  loading={loading}
                  key={product.id}
                  product={product}
                />
              ) : null})
          }
        </Fragment>
      )}
    </ProductGridContainer>
  );
};

export default ProductList;
